import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { Box, Card, DialogActions, DialogContent, DialogTitle, Grid, Paper, styled } from '@mui/material';
import { PDF_example, PDF_example3page } from '../DocumentPersonalComponent/Base64';
import AddIcon from '@mui/icons-material/Add';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import { BigButton } from '../SignPDF/BigButton';
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import { blobToURL } from "../../../../utils/Utils";
import { useEffect, useRef, useState } from 'react';
import DraggableText from '../SignPDF/DraggableText';
import dayjs from 'dayjs';
import PagingControl from '../SignPDF/PagingControl';
import { BigButtonSave } from '../SignPDF/BigButtonSave';
import { BigButtonAddSign } from '../SignPDF/BigButtonAddSign';
import { BigButtonAddWidth } from '../SignPDF/BigButtonAddWidth';
import sections from "../../../../Image/sections.png";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { xywhOfPDF } from '../DocumentPersonalComponent/SignSignatureDialog';
import { PdfArray } from '../DocumentPersonalComponent/IndexDocumentPer';


const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<unknown>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});
export interface AppState {
    pdf: string | null;
    autoDate: boolean;
    signatureURL: string | null;
    position: { x: number; y: number; offsetX: number; offsetY: number, width: number, height: number } | null;
    signatureDialogVisible: boolean;
    textInputVisible: any;
    pageNum: number;
    totalPages: number;
    pageDetails: { originalHeight: number; originalWidth: number } | null;
}

interface IDataNameDoc {
    base64OfPDF: PdfArray
    base64OfSignDraggable: string
    open: boolean
    setXywhOfPDF: (value: xywhOfPDF) => void
    setOpen: (value: boolean) => void
    setOpen2?: (value: boolean) => void
    checkPage: number
    setOpenConfirmDialog?: (value: boolean) => void
    pageOfSignPDF: (value: number) => void
    typeOfPDF: string
    priorityOfPDF: string
}

const DialogShowSignPDFV1: React.FC<IDataNameDoc> = ({ base64OfSignDraggable, open, setOpen, checkPage, setXywhOfPDF, base64OfPDF, setOpen2, setOpenConfirmDialog, pageOfSignPDF,typeOfPDF,priorityOfPDF }) => {

    // const [open, setOpen] = useState(openPDF1);
    const [state, setState] = useState<AppState>({
        pdf: null,
        autoDate: true,
        signatureURL: null,
        position: null,
        signatureDialogVisible: false,
        textInputVisible: null,
        pageNum: 0,
        totalPages: 0,
        pageDetails: null,
    });
    const [YpageHeightOfPDF, setYPageHeightOfPDF] = useState<number>(0);
    const [XpageWidthOfPDF, setXPageWidthOfPDF] = useState<number>(0);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);
    const [HeightOfImageSrc, setHeightOfImageSrc] = useState<number>(100);
    const pageWidth = windowWidth * 0.8; // 80% of the window width
    const pageHeight = (pageWidth / 800) * 1200;
    const documentRef = useRef<HTMLDivElement>(null);
    const nodeRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);
    const [scroll, setScroll] = React.useState<DialogProps['scroll']>('paper');

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
            setWindowHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const handleClickOpen = (scrollType: DialogProps['scroll']) => {
        setOpen(true);
        setScroll(scrollType);
    };

    const handleClose = () => {
        if (checkPage === 1 || checkPage === 3) {
            setOpen(false);
        } else if (checkPage === 2) {
            setOpen(false);
            setOpen2 && setOpen2(true);
        }
    };

    const handleCloseIconX = () => {
        setOpen(false);
        setOpen2 && setOpen2(false);
    };

    return (
        <Grid>
            {/* <Button variant="outlined" onClick={() => handleClickOpen('paper')}>
                Open full-screen dialog
            </Button> */}
            <Dialog
                scroll={scroll}
                fullWidth
                maxWidth="lg"
                // fullScreen
                //  aria-labelledby="scroll-dialog-title"
                //    aria-describedby="scroll-dialog-description"
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
                PaperProps={{
                    sx: {
                        overflowY: 'auto',
                        scrollbarWidth: 'none', // Firefox
                        '&::-webkit-scrollbar': {
                            display: 'none' // Chrome, Safari
                        },
                        borderRadius:3
                    }
                }}
            >
                {/* <AppBar sx={{ position: 'relative', backgroundColor: '#ffffff' }}> */}
                {/* <DialogTitle id="scroll-dialog-title">Subscribe</DialogTitle> */}
                <Grid container sx={{ width: '100%' }}>
                    {/* <div > */}
                    <Grid item pt={2} pb={2} justifyContent={'center'} display={'flex'} alignContent={'center'} gap={3}
                        sx={{
                            position: "sticky",
                            top: 0,  // This ensures it sticks to the top
                            backgroundColor: "#fff",
                            boxShadow: "0px 6px 10px rgba(0, 0, 0, 0.15)",
                            zIndex: 1100,
                            width: '100%',
                        }}>
                        <Box justifyContent={'center'} display={'flex'} alignContent={'center'}>

                            <Grid item
                                justifyContent={'start'}
                                sx={{
                                    position: 'absolute',
                                    top: 10,
                                    left: 18
                                }}>
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    sx={{ color: '#4c4c4c' }}
                                    onClick={handleClose}
                                    aria-label="close"
                                >
                                    <ArrowBackIosIcon />
                                    <Typography fontSize={22}>กลับ</Typography>

                                </IconButton>
                            </Grid>

                            {/* <BigButton
                                marginRight={8}
                                title="Reset"
                                onClick={() =>
                                    setState({
                                        pdf: null,
                                        autoDate: true,
                                        signatureURL: null,
                                        position: null,
                                        signatureDialogVisible: false,
                                        textInputVisible: false,
                                        pageNum: state.pageNum,
                                        totalPages: state.totalPages,
                                        pageDetails: null,
                                    })
                                }
                            /> */}

                            <BigButtonAddWidth
                                marginRight={8}
                                // title={"" + HeightOfImageSrc + '%'}
                                title={"เพิ่มขนาด"}
                                onClick={async () => {
                                    if (state.position) {

                                        // console.log("ppppppppppppppp", state.position)
                                        // console.log("first", state.position)
                                        if (nodeRef.current) {
                                            // console.log("clientWidth", nodeRef.current.clientWidth);
                                            var nodeRefcurrentclientWidth: number = 0
                                            nodeRefcurrentclientWidth = nodeRef.current.clientWidth
                                            const width = nodeRefcurrentclientWidth > state.position.width ? nodeRefcurrentclientWidth : state.position.width
                                            let WXmax = await (width / XpageWidthOfPDF)
                                            //  console.log("WXmax", WXmax)
                                            var nccspx = (nodeRef.current.clientWidth + state.position.x) + 5
                                            //    console.log("nccspx", nccspx)
                                            //    console.log("nccspx", nccspx)
                                            if (nccspx < 794 && WXmax < 0.59) {
                                                // console.log("nccspx เข้า", nccspx)
                                                setHeightOfImageSrc(HeightOfImageSrc + 5)
                                            }
                                            //    console.log("ccc", ccc)
                                        }
                                        // nodeRef
                                        // console.log("XpageWidthOfPDF", XpageWidthOfPDF)
                                        // console.log("YpageHeightOfPDF", YpageHeightOfPDF)
                                        // setHeightOfImageSrc(HeightOfImageSrc + 5)
                                    }

                                }
                                }
                            />

                            <BigButton
                                marginRight={8}
                                // title={"" + HeightOfImageSrc + '%'}
                                title={"ลดขนาด"}
                                onClick={() => {
                                    if (HeightOfImageSrc > 30 && state.position) {
                                        var ccc = HeightOfImageSrc - 5
                                        setHeightOfImageSrc(ccc)
                                    }
                                }
                                }
                            />

                           <Divider
                                orientation="vertical"
                                variant="middle"
                                flexItem
                                sx={{ bgcolor: '#808080', width: '2px', marginRight: 3, marginLeft: 2 }}
                            />

                            <BigButtonAddSign
                                disabled={state.textInputVisible}
                                marginRight={8}
                                title="เพิ่มตำแหน่งลายเซ็น"
                                onClick={() => {
                                   let OpenPageNum = 0
                                   let xOfOpenPage = 0
                                   let yOfOpenPage = 0
                                   let setScrollHeight = 3
                                    if (typeOfPDF === "register") {
                                        setScrollHeight = 2
                                        OpenPageNum = 2
                                        xOfOpenPage = 475
                                        yOfOpenPage = 870
                                    } else {
                                        OpenPageNum = 4
                                        if (priorityOfPDF === "1") {
                                            xOfOpenPage = 464
                                            yOfOpenPage = 509
                                        } else if (priorityOfPDF === "2") {
                                            xOfOpenPage = 455
                                            yOfOpenPage = 690
                                        } else if (priorityOfPDF === "3") {
                                            xOfOpenPage = 102
                                            yOfOpenPage = 691
                                        } else if (priorityOfPDF === "4") {
                                            xOfOpenPage = 105
                                            yOfOpenPage = 514
                                        }
                                    }
                                    setState((prevState) => ({
                                        ...prevState,
                                        textInputVisible: true,
                                        pageNum: OpenPageNum,
                                        position: {
                                            x: xOfOpenPage,
                                            y: yOfOpenPage,
                                            offsetX: xOfOpenPage,
                                            offsetY: yOfOpenPage,
                                            width: prevState.position?.width || 0, // Default width
                                            height: prevState.position?.height || 0  // Default height
                                        }
                                    }))
                                    if (contentRef.current) {
                                        const el = contentRef.current;
                                        // console.log("el.scrollHeight", el.scrollHeight)
                                        el.scrollTop =  (el.scrollHeight / setScrollHeight); // Scroll to the position of the element
                                      }
                                }
                            }
                            />

                            <BigButtonSave
                                disabled={!(state.position)}
                                marginRight={8}
                                title={checkPage === 2 || checkPage === 3  ? "บันทึกและยืนยันเอกสาร" : "บันทึกตำแหน่งลายเซ็น"}
                                onClick={async () => {
                                    try {
                                        if (state.position) {
                                            var nodeRefcurrentclientWidth: number = 0
                                            var nodeRefcurrentclientHeight: number = 0
                                            if (nodeRef.current) {
                                                nodeRefcurrentclientWidth = nodeRef.current.clientWidth
                                                nodeRefcurrentclientHeight = nodeRef.current.clientHeight
                                            }
                                            // console.log("nodeRefcurrentclientWidth", nodeRefcurrentclientWidth)
                                            // console.log("state.position.width", state.position.width)
                                            const width = nodeRefcurrentclientWidth > state.position.width ? nodeRefcurrentclientWidth : state.position.width
                                            const height = nodeRefcurrentclientHeight > state.position.height ? nodeRefcurrentclientHeight : state.position.height
                                            // console.log("width", nodeRefcurrentclientWidth)
                                            // console.log("width sum", width)
                                            let X0Xmax = await (state.position.x / XpageWidthOfPDF)
                                            let Y0reverse = await (YpageHeightOfPDF - (state.position.y + height))
                                            let Y0Ymax = await (Y0reverse / YpageHeightOfPDF)
                                            let WXmax = await (width / XpageWidthOfPDF)
                                            let HYmax = await (height / YpageHeightOfPDF)


                                            setXywhOfPDF({
                                                doc_type: base64OfPDF.type,
                                                x: String(X0Xmax),
                                                y: String(Y0Ymax),
                                                width: String(WXmax),
                                                height: String(HYmax)
                                            })
                                            pageOfSignPDF((state.pageNum + 1))

                                            if (checkPage === 1) {
                                                setOpen(false)
                                                setOpen2 && setOpen2(true)
                                            } else if (checkPage === 2 || checkPage === 3) {
                                                setOpenConfirmDialog && setOpenConfirmDialog(true)
                                            }
                                            // console.log("xxxom:", { x: X0Xmax, y: Y0Ymax, width: WXmax, height: HYmax })
                                        }
                                    } catch (error) {
                                        console.log(error)
                                    }
                                }}
                            />
                            <Grid item
                                justifyContent={'flex-end'}
                                sx={{
                                    position: 'absolute',
                                    top: 15,
                                    right: 18
                                }}>
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    sx={{ color: '#4c4c4c' }}
                                    onClick={handleCloseIconX}
                                    aria-label="close"
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Grid>


                        </Box>
                    </Grid>
                    {/* </div> */}

                </Grid>

                <DialogContent dividers={scroll === 'paper'} sx={{ padding: 0 }} ref={contentRef}>
                    <Grid justifyContent={'center'} display={'flex'} style={{ backgroundColor: '#fff' }}>

                        <Grid style={{ maxWidth: 900 }}>

                            <Grid sx={{ paddingTop: 3 }} container alignItems={'center'}>
                                <Grid item mr={1}> <img
                                    src={sections}
                                    alt="sections"
                                    style={{
                                        width: "20px",
                                        height: "20px",
                                    }}
                                /></Grid>
                                <Grid item mr={1}>

                                    <Typography sx={{ fontSize: 20 }}>หัวข้อ: </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography sx={{ color: '#4c4c4c', fontSize: 17 }}>{base64OfPDF.type === 'register' ? 'ใบสมัครเข้าร่วมตามนโยบาย “๓๐ บาทรักษาทุกที่ ด้วยบัตรประชาชนใบเดียว” ของหน่วยบริการเอกชน' : 'เอกสารข้อตกลงการแบ่งปันข้อมูลส่วนบุคคล (DSA)'}</Typography>
                                </Grid>
                            </Grid>
                            {true && (
                                <div style={{ paddingTop: 16 }}>

                                    <div style={{ maxWidth: 600, margin: "0 auto", marginTop: 3 }}>

                                    </div>
                                    {/* Heigh {YpageHeightOfPDF} / Width {XpageWidthOfPDF} */}
                                    {/* {HeightOfImageSrc >= 110 ? "": "" } */}
                                    {/* <Box boxShadow={2}> */}
                                    <div
                                        ref={documentRef}
                                        style={{
                                            width: '805px',
                                            // margin: "20px auto",
                                            // marginTop: 8,
                                            // borderRight: "3px solid #999",
                                            // borderLeft: "3px solid #999",
                                            // borderTop: "3px solid #999",
                                            // borderBottom: "3px solid #999",
                                            border: "3px solid #a8a9ab",
                                            borderRadius: 2,
                                            position: "relative",
                                        }}
                                    >
                                        {state.textInputVisible && (
                                            <DraggableText
                                                base64OfSignDraggable={base64OfSignDraggable}
                                                nodeRef={nodeRef}
                                                HeightOfImageSrc={HeightOfImageSrc}
                                                setHeightOfImageSrc={setHeightOfImageSrc}
                                                initialImage={
                                                    state.textInputVisible === "date"
                                                        ? dayjs().format("M/D/YYYY")
                                                        : undefined
                                                }
                                                state={state}
                                                onCancel={() =>
                                                    setState((prevState) => ({
                                                        ...prevState,
                                                        textInputVisible: false,
                                                    }))
                                                }
                                                onEnd={async (position: any) => {
                                                    // console.log("Position onEnd:", position);
                                                    const width = position.width || 0;
                                                    const height = position.height || 0;
                                                    // console.log('width :>> ', width);
                                                    //    let X0Xmax = await (position.x / XpageWidthOfPDF)
                                                    //    let Y0reverse = await (YpageHeightOfPDF - (position.y + height))
                                                    //    let Y0Ymax = await (Y0reverse / YpageHeightOfPDF)
                                                    //    let WXmax  = await (width / XpageWidthOfPDF)
                                                    //    let HYmax  = await (height / YpageHeightOfPDF)
                                                    //    console.log("xxxom:", {x: X0Xmax, y:Y0Ymax, w: WXmax, h: HYmax})
                                                    //    var  Yreverse = pageHeightOfPDF - (position.y + height)
                                                    // if (nodeRef.current) {
                                                    //     console.log("clientWidth", nodeRef.current.clientWidth);
                                                    // }

                                                    //    position.y
                                                    // console.log('height :>> ', position.height);
                                                    setState((prevState) => ({
                                                        ...prevState,
                                                        position: {
                                                            x: position.x,
                                                            y: position.y,
                                                            width,
                                                            height,
                                                            offsetX: position.offsetX || 0,
                                                            offsetY: position.offsetY || 0,
                                                        },
                                                    }));
                                                }}
                                                // onSet={handleAddText}
                                                bounds={documentRef.current ? "parent" : false} // กำหนด bounds เป็น container ของ PDF
                                            />
                                        )}



                                        <Document
                                            file={`data:application/pdf;base64,${base64OfPDF.pdf_base64}`}
                                            onLoadSuccess={(data: { numPages: any }) => {
                                                // console.log("data :>> ", data);
                                                setState((prevState) => ({
                                                    ...prevState,
                                                    totalPages: data.numPages,
                                                }));
                                            }}
                                        >
                                            <Page
                                                pageNumber={state.pageNum + 1}
                                                width={800}
                                                // height={1200}
                                                onLoadSuccess={(data) => {
                                                    // console.log("PageHeight", data.height)
                                                    // console.log("PageWidth", data.width)
                                                    setYPageHeightOfPDF(data.height)
                                                    setXPageWidthOfPDF(data.width)
                                                    // console.log("width", data.view[1])
                                                    // console.log("height", data.view[4])
                                                    // console.log("width", data.view[2])
                                                    // console.log("height", data.view[3])
                                                    setState((prevState) => ({
                                                        ...prevState,
                                                        pageDetails: data,
                                                    }));
                                                    console.log("Active Page Loaded:", state.pageNum + 1); // Log active page when it's loaded
                                                }}
                                            />
                                        </Document>
                                    </div>
                                    {/* </Box> */}
                                    <Grid sx={{ display: "flex", justifyContent: "center" }}>

                                        {/* <button onClick={() => setScale((prevScale: number) => prevScale + 0.2)}><ZoomInIcon /></button> */}
                                        {/* <button onClick={() => setScale((prevScale: number) => Math.max(prevScale - 0.2, 0.5))}>Zoom Out</button> */}
                                        {/* <button onClick={() => setScale(0.6)}>Reset</button> */}
                                    </Grid>

                                </div>
                            )}
                        </Grid>

                    </Grid>
                </DialogContent>
                <Paper elevation={3}>
                <DialogActions style={{ display:'flex',justifyContent:'center'}} >
                    <PagingControl
                        pageNum={state.pageNum}
                        setPageNum={(num) =>
                            setState((prevState: any) => ({ ...prevState, pageNum: num }))
                        }
                        totalPages={state.totalPages}
                    />
                </DialogActions>
                </Paper>
                {/* <Grid sx={{ width: "100%", height: "100%" }}>
                    <iframe
                        src={`data:application/pdf;base64,${PDF_example}`}
                        // src="https://example.com/sample.pdf"
                        width="100%"
                        height="100%"
                        style={{ border: "none" }}
                    />
                </Grid> */}


            </Dialog>
        </Grid>
    );
}

export default DialogShowSignPDFV1